
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import DropdownOption from "@/entities/DropdownOption";
  import countries from "@/data/locations/countries";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class ProfileCountrySelect extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: DropdownOption[];
    @Prop({ type: Boolean, default: false }) multiple!: boolean;
    @Prop({ type: Boolean, default: false}) disabled!: boolean;
    @Prop({ type: String, default: "Select country"}) readonly placeholder!: string;

    valueToSearch: string = ""

    get options(): DropdownOption[] {
      if (!this.valueToSearch) {
        return countries;
      }

      return countries.filter(({name}) => {
        const countryName = name.toLowerCase();
        const searchValue = this.valueToSearch.toLowerCase();
        return countryName.includes(searchValue);
      });
    }

    handleSearch(valueToSearch: string): void {
      this.valueToSearch = valueToSearch;
    }

    handleInput(val: DropdownOption[]): void {
      this.$emit("input", val);
    }
  }
